import { render, staticRenderFns } from "./registerDefault.vue?vue&type=template&id=79dd6507&scoped=true"
import script from "./registerDefault.vue?vue&type=script&lang=js"
export * from "./registerDefault.vue?vue&type=script&lang=js"
import style0 from "./registerDefault.vue?vue&type=style&index=0&id=79dd6507&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7907ed7515d572276d45114f834f04a7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dd6507",
  null
  
)

export default component.exports